// extracted by mini-css-extract-plugin
export var labelWrapper = "_dr-0";